<template>
  <Card class="menu-card">
    <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">分馆总表统计</el-menu-item>
      <el-menu-item index="2">分馆经营统计</el-menu-item>
    </el-menu>
    <div slot="content">
      <DeptSummary v-if="menuIndex == 1" />
      <DeptOperation v-if="menuIndex == 2" />
    </div>
  </Card>
</template>

<script lang="js">
import DeptOperation from "./DeptOperation.vue"; // 分馆总表
import DeptSummary from "./DeptSummary.vue"; // 科室管理
export default {
  name: "Dept",
  components: { DeptOperation, DeptSummary },
  data() {
    return {
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('deptIndex')
    if (index) this.activeIndex = this.menuIndex = index;
  },
  methods:{
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key;
      this.$session.set('deptIndex', key);
    }
  }
};
</script>